import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from './app-config.service';
import { ErrorHandlerService } from './error-handler.service';
import { RedactionAnnotation } from '../components/review/redaction-annotation/redaction-annotation.model';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HighlightColor } from '../components/review/redaction-annotation/highlight-color.model';

@Injectable({
  providedIn: 'root'
})
export class AnnotationService {

  constructor(private http: HttpClient, private appConfigService: AppConfigService, private errorHandler: ErrorHandlerService) { }

  public getHighlightColors(key: string): Observable<HighlightColor[]> {
    return this.http.get<HighlightColor[]>(`${this.appConfigService.getConfig().webApi}/api2/HighlightColors/${key}`)
      .pipe(catchError(this.errorHandler.handleError<HighlightColor[]>(`get annotation highlight colors`)));
  }

  public getAnnotations(annotationId: string): Observable<RedactionAnnotation[]> {
	return this.http.get<RedactionAnnotation[]>(`${this.appConfigService.getConfig().webApi}/api2/Annotations/${annotationId}`)
      .pipe(catchError(this.errorHandler.handleError<RedactionAnnotation[]>(`get annotations`)));
  }
}
